module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("THE SAMSON SYNDROME ")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct2"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#aa_1",
      "id": "bb_1"
    }
  }, [_c('b', [_vm._v("ONE")])])]), _vm._v(" "), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "p0019-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#aa_1"
    }
  }, [_c('b', [_vm._v("STRONG MEN TEND TO DISREGARD BOUNDARIES")])])]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "p0019-02-1"
    }
  }, [_c('span', [_c('i', [_vm._v("Mickey Mantle’s carousing knew no limits. I’d say he easily took five years off of his life.")])])]), _vm._v(" "), _c('p', {
    staticClass: "extr",
    attrs: {
      "id": "p0019-03-3"
    }
  }, [_c('span', [_vm._v("—WHITEY FORD")])]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "p0019-04-4"
    }
  }, [_c('span', [_c('i', [_vm._v("The gateway to life is small, and the road is narrow.")])])]), _vm._v(" "), _c('p', {
    staticClass: "extr",
    attrs: {
      "id": "p0019-05-6"
    }
  }, [_c('span', [_vm._v("—JESUS CHRIST (MATTHEW 7:14)")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0019-06-7"
    }
  }, [_vm._v("BOUNDARIES. FROM DAY ONE WE HAVE TO CONTEND with them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-07-9"
    }
  }, [_vm._v("Moments after your birth you were wrapped in a blanket and put into a bed that looked something like a fish tank on wheels. Then when you got home, your parents put you in a bed that had bars like a jail cell. And when it was time to play, they dropped you into something called a “playpen.” At first these enclosures were of no concern. But as your motor skills developed and your mobility increased, you began to feel quite restricted.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-07-11"
    }
  }, [_vm._v("And then one day it hit you: You were being tricked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("They called it a "), _c('i', [_vm._v("playpen")]), _vm._v(" to make it sound enticing. They filled it with your favorite toys and they always talked mushy baby talk when they stuck you in it. But suddenly you knew. You saw the truth as clearly as if it were written on the wall in crayon: You were being held prisoner. They could call the devilish contraption anything they wanted, but a cage by any other name is still a cage.")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-01-1"
    }
  }, [_vm._v("And that’s when you rebelled. Big time. At the top of your lungs. With some kicking and tears thrown in for good measure. And you didn’t stop until somebody came and liberated you.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-01-3"
    }
  }, [_vm._v("But your victory was short-lived, for there were more boundaries in your future.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-01-4"
    }
  }, [_vm._v("“Go to your room.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-01-5"
    }
  }, [_vm._v("“Sit in that chair until I say you can get up.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-01-6"
    }
  }, [_vm._v("“It’s your bedtime.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-01-7"
    }
  }, [_vm._v("“If you ever say that again, I’ll wash your mouth out with soap!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-01-8"
    }
  }, [_vm._v("“Change the channel. You’re not watching that garbage!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-01-9"
    }
  }, [_vm._v("“Be home by eleven.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-01-10"
    }
  }, [_vm._v("“No, you can’t get a tattoo.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-02-12"
    }
  }, [_vm._v("If you were like most kids, you couldn’t wait to turn eighteen. You dreamed of a life without parental authority. No more boundaries. No more restrictions. Finally, after years of oppression, you would be free to live your life the way you saw fit. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-05-15"
    }
  }, [_vm._v("But it was a pipe dream.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "txr4",
    attrs: {
      "id": "P0020-04-14"
    }
  }, [_vm._v("NO MATTER HOW OLD YOU ARE AS YOU READ THIS BOOK, YOU CAN STILL COUNT NUMEROUS BOUNDARIES THAT HEM YOU IN.")])])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-05-16"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("No matter how old you are as you read this book, you can still count numerous boundaries that hem you in. If it’s not the speed-limit signs you pass on your way ")]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("to work, it’s your doctor’s orders to stay away from all your favorite foods. Yes, boundaries are a fact of life. And though we spend our lives grousing about them and trying to stretch them as far as possible, we must admit that we wouldn’t last long without them. With a few exceptions, boundaries are designed to keep us on track and out of trouble.")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0021-02-2"
    }
  }, [_vm._v("That’s why God laid out some specific boundaries for Samson at the very beginning of his life. Check out these specific instructions that an angel of the Lord gave to Samson’s mother: “You will become pregnant and give birth to a son, and his hair must never be cut. For he will be dedicated to God as a Nazirite from birth. He will rescue Israel from the Philistines” (Judg. 13:5).")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0021-02-3"
    }
  }, [_vm._v("Numbers 6 gives a detailed description of the Nazirite vow. It was generally taken voluntarily for a period of thirty or sixty days by people who had a desire for a deeper, more intimate connection with God. During this time they were to observe some very specific boundaries. They had to stay away from things that were "), _c('i', [_vm._v("unwise")]), _vm._v(" (strong drink), "), _c('i', [_vm._v("unclean")]), _vm._v(" (dead bodies), and "), _c('i', [_vm._v("unnecessary")]), _vm._v(" (the cutting of hair). It was a vow that required great devotion and attention to detail, and God was insisting that Samson live under it, not for a month or two, but for his entire life.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0021-02-4"
    }
  }, [_vm._v("Seems oppressive, doesn’t it? Sounds like God was determined not to let Samson have any fun at all. But there was more to it than that.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0021-02-5"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("You see, God made Samson and fully understood his personality. As a strong “alpha male,” he would be gutsy and bodacious. Daring and impulsive. Reckless and carefree. Of course, these were the qualities that would serve him well as a military commander leading an insurrection against the Philistines. But they were also the traits that could get him into trouble spiritually and lead him ")]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("far from God. That’s why God placed him under the Nazirite vow. It was His way of keeping Samson from spinning out of control. ")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0022-02-1"
    }
  }, [_vm._v("Unfortunately, it didn’t work. As we will see throughout this book, Samson only respected God’s boundaries when it suited him. The rest of the time he did whatever he wanted. And he wasn’t afraid of getting into trouble because he believed his great strength would bail him out of any predicament he might get into. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0022-P-1"
    }
  }, [_vm._v("Sound familiar?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0022-02-2"
    }
  }, [_vm._v("Maybe you know a guy like that.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0022-02-3"
    }
  }, [_vm._v("Maybe you "), _c('i', [_vm._v("are")]), _vm._v(" a guy like that.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0022-02-4"
    }
  }, [_vm._v("Maybe you’re a guy who, like Samson, was taught as a child to respect God’s law. You went to church every Sunday, memorized the Ten Commandments, starred in numerous Sunday-school productions, and had every little old lady in the church thinking you were just the cutest thing they’d ever seen. But at some point—possibly during your high-school or college years—those Commandments started feeling a little restrictive, like a suit that’s a couple of sizes too small. You found that you couldn’t run with the fun crowd and be a staunch Ten-Commandments guy at the same time, so you started making a few compromises. Nothing serious. Just a little fooling around. After all, boys will be boys.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0022-02-5"
    }
  }, [_vm._v("That’s exactly how it started with Samson. He didn’t wake up one day and suddenly decide to trash his Nazirite vow. Instead, he slipped gradually into a life of disobedience by making a series of small compromises. And every time he did, you can be sure he was relying on his great strength to be his safety net. “I can handle it” was his motto.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0022-02-6"
    }
  }, [_vm._v("Is it yours? ")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0022-P-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("What are you “handling” right now? Are there some fences in your life that have been trampled by your desire for money, ")]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("power, or pleasure? Are there some things you’re doing that you know God doesn’t approve of? Some things that you’re having to hide? Some things that would horrify your wife and children, not to mention those little old ladies who adored you as a child? ")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0023-02-1"
    }
  }, [_vm._v("Strong men who have great confidence in their ability to “handle things” often disregard boundaries. But they do so at great risk. Samson’s tragic story reveals two bad things that will eventually happen if you continually disregard God’s boundaries. ")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "p0023-03-2"
    }
  }, [_c('b', [_vm._v("YOU WILL BE SHACKLED")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0023-04-3"
    }
  }, [_vm._v("On July 6, 1999, twenty-seven-year-old Daniel Dukes went to SeaWorld here in Orlando. He gave every appearance of being an ordinary tourist, but he wasn’t. At closing time, as all the other guests were leaving the park, he ducked into a hiding place and stayed put until the park was empty. Then, sometime during the night, he made his way to the pool where a five-ton killer whale named Tillicum was being kept. He stripped down to his swimming trunks, folded his clothes neatly, and jumped in.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0023-05-5"
    }
  }, [_vm._v("Nobody knows for sure what happened next. Some experts believe the whale may have been startled by the man’s sudden appearance. In his fear, he may have dived suddenly, creating a vortex that pulled the man under and rendered him helpless. Others believe it’s more likely that the whale thought the man was a toy and dragged him around the pool for fun, keeping him underwater until he drowned. Either way, Dukes’s body was found the next morning draped over Tillicum’s back.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0023-05-7"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("When I first heard that story on the news I thought it was a perfect picture of the consequences of sin. We climb over fences, not to wreak havoc and destruction, but just to have a little fun. The ")]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("problem is, we underestimate the danger. We intend to stay only a little while, but sin grabs us in its teeth and refuses to let go.")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0024-02-2"
    }
  }, [_vm._v("Samson is a case in point. His intention was never to fight against God. He was just a fun-loving guy out looking for a good time. Like so many strong men today, he didn’t think his sin was any big deal. But it’s clear as you read his story that the older he got, the more sin held him in its grip. Think about the night he was in bed with a prostitute while a band of Philistine soldiers was surrounding her house (Judg. 16:1–3). Somehow he managed to slip out under the cover of darkness in a James Bond–like escape. But even that close call wasn’t enough to bring him to his senses. By then he was hopelessly shackled.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0024-02-3"
    }
  }, [_vm._v("Today our countless drug and alcohol rehab centers are vivid proof that people are still being shackled by sin. And that’s not to mention all the therapists and counselors who spend eight hours a day trying to help their patients sort through their sin-induced problems. I daresay that none of those patients ever intended to become so tangled up and overwhelmed, but it happened because they failed to recognize the addictive and destructive nature of sin. It will reduce even the strongest men to pathetic buffoons.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0024-02-4"
    }
  }, [_vm._v("At the end of Samson’s life we see him doing hard labor in a Philistine prison. He’s blind and exhausted, staggering around and bumping into things, falling down and causing hysterical laughter among his captors. I pray that every man who reads this book will close his eyes and let that image sink in. It is perhaps the best picture we have in all the Bible of the destructive power of sin.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0024-02-5"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("I’ll say it as simply as I can. If you’ve been willfully climbing over God’s boundaries to indulge in sin, you must stop it. If you ")]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("don’t, you could wake up someday and, like Samson, find that you’ve been shackled.")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0025-02-2"
    }
  }, [_vm._v("But that’s not all.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "p0025-03-4"
    }
  }, [_c('b', [_vm._v("YOU WILL BE SHAMED")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0025-04-5"
    }
  }, [_vm._v("Samson’s shame reached its peak when we see him blind and bound, stumbling and bumbling to the delight of his enemies. But the Bible contains other equally tragic stories about strong men who disregarded God’s boundaries and suffered public shame as a result.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0025-05-8"
    }
  }, [_vm._v("David’s is perhaps the most familiar.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0025-05-9"
    }
  }, [_vm._v("You remember how he flexed his political muscle and had the gorgeous Bathsheba brought to his bedroom. Apparently, he wasn’t anticipating anything more than a one-night stand. His idea was to use her and lose her. But when she turned up pregnant, the need for damage control became paramount, as it always does with powerful politicians. It would have been nice if he’d simply repented and thrown himself on the mercy of the Lord, but because he was now "), _c('i', [_vm._v("shackled")]), _vm._v(" by sin (remember, he had a house full of wives), that option was never considered. Instead, he formulated a detailed plan to cover his tracks, which ultimately involved eliminating Bathsheba’s husband. It worked, and in no time she had moved into the palace and was picking out draperies. It was all very neat and tidy, except for one thing: God had been watching David’s every move.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0025-05-12"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("You’ll recall how God sent Nathan to confront David. The message he brought is one that should send chills down your spine if you’re a man who dabbles in secret sin: “Because of what you have done, I, the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(", will cause your own household to ")]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("rebel against you. I will give your wives to another man, and he will go to bed with them in public view. "), _c('i', [_vm._v("You did it secretly, but I will do this to you openly in the sight of all Israel”")]), _vm._v(" (2 Sam. 12:11–12, author’s emphasis).")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0026-02-2"
    }
  }, [_vm._v("God has a way of bringing the secret sins of strong men out into the open. Just ask Bill Clinton. Or Jesse Jackson. Or any one of a million other humiliated men who thought they were sly and sneaky enough to step over God’s boundaries and get away with it.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "txr4",
    attrs: {
      "id": "P0026-04-5"
    }
  }, [_vm._v("IF YOU’VE TRAMPLED GOD’S FENCES AND ARE PARTAKING OF THINGS THAT HE HAS SAID ARE OFF LIMITS, YOU NEED TO UNDERSTAND THAT YOU ARE IN GRAVE DANGER OF BEING SHAMED.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0026-05-6"
    }
  }, [_vm._v("Right now, if you’ve trampled God’s fences and are partaking of things that he has said are off limits, you need to understand that you are in grave danger of being shamed. You have set yourself in opposition to almighty God and are just asking to be publicly broken and humiliated. Zephaniah 1:12 says, “I will search with lanterns in Jerusalem’s darkest corners to find and punish those who sit contented in their sins, indifferent to the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(", thinking he will do nothing at all to them.” My friend, if that verse doesn’t shake you out of your moral complacency, I fear that nothing ever will. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0026-06-8"
    }
  }, [_vm._v("But if it does . . . if it helps you realize that you need to make some changes in the way you’ve been living, let me offer you a simple plan of action.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "p0026-07-10"
    }
  }, [_c('b', [_vm._v("YOU CAN BE SPARED")])])]), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0026-08-11"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("Four simple steps will ensure that you don’t have to endure the shackles and the shame a wandering life always seems to bring. ")]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('i', [_vm._v("First, REMEMBER the joy of living within God’s boundaries")]), _vm._v(". It’s entirely possible that you’ve been living outside them for so long that you’ve forgotten how good it feels to be on the inside.")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0027-02-2"
    }
  }, [_vm._v("A man named Jerry made this discovery about himself when he pulled an innocent-looking envelope out of his mailbox. He opened it and removed an invitation to the twenty-year reunion of his Bible-college graduating class. He’d graduated from the school and spent three years in youth ministry before losing his job during a bitter church split. Frustrated and disillusioned, he left the ministry and pursued a career as a police officer. He was good at the job and earned numerous awards and citations. But the environment took a toll on his commitment to the Lord. Within a year, he had dropped out of church, was hanging out after hours at a bar near his precinct station, and was picking up the language of the street. He also got married and divorced twice within a five-year period and fathered a son that he hardly ever saw.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0027-02-4"
    }
  }, [_vm._v("But the invitation stopped him cold.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0027-02-5"
    }
  }, [_vm._v("On the front of the card was a picture of his graduating class. There he was: third row, fourth from the left. Standing right next to the guy who had been his roommate and best friend. Two rows in front of the preacher’s daughter he’d been madly in love with during his junior year. Looking at himself standing among his old friends, he noticed that they were all grinning from ear to ear. Suddenly, he felt a swirl of emotion. More than nostalgia, it was a rush of regret. He’d changed so much since then, and not for the better. Though successful in the eyes of the world, he had lost virtually all of what had once given his life meaning and purpose. Staring at his own smiling face in the picture, he wondered how many years it had been since he’d been "), _c('i', [_vm._v("that")]), _vm._v(" happy.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0028-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("The good news is that Jerry picked up the phone that very day and called his old roommate. He ended up attending the reunion and reconnecting with some of his old friends. It was a small step, but the first step in a long journey back to his first love and to the happiness he’d all but forgotten.")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0028-01-1"
    }
  }, [_vm._v("One of the blessings of being in the preaching ministry is that I get to meet a lot of Jerrys, a lot of returning prodigals who always remind me that life is better inside God’s boundaries. Recently a wandering prodigal came home during one of our worship services. He squeezed me so tight he just about broke my ribs. As he sobbed on my shoulder he kept saying over and over, “It’s so good to be home . . . so good to be home . . . so good to be home . . .” Every time something like that happens I say to myself, “Mark, there’s no reason for you to ever go wandering off. No matter what the world tries to tell you, life really is better on the inside.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0028-01-3"
    }
  }, [_vm._v("Maybe this would be a good time for you to look back and remember.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0028-01-4"
    }
  }, [_c('i', [_vm._v("Second, RENOUNCE any activity that has lured you outside God’s boundaries in the past")]), _vm._v(". I love football, but I’ve never quite figured out what it is about Monday night that makes any game seem like a miniature Super Bowl. Even when the two worst teams in the league are matched up, all the rowdies still get together, order in mountains of pizza and beer, and hoot and holler like there’s no tomorrow.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0028-01-5"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("In one neighborhood, Andy was the self-proclaimed King of Monday Night. His house was "), _c('i', [_vm._v("the")]), _vm._v(" place to be when ol’ Hank Jr. shouted, “Are you ready for some football?” He had the two most desired Monday night amenities: a big screen TV and an oversized refrigerator. And he lacked the one most undesired ")]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("Monday night encumbrance: a wife. Yes sir, Andy’s place was Monday night heaven.")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0029-02-2"
    }
  }, [_vm._v("Until he went and ruined everything by becoming a Christian. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0029-P-1"
    }
  }, [_vm._v("Ruined everything for his buddies, that is, because, with his new commitment to the Lord came a few new rules, such as “No booze.” When Andy informed his rowdy friends that they would now be drinking Pepsi on Monday nights, they groaned as if he had said, “Castor Oil.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0029-02-3"
    }
  }, [_vm._v("Not surprisingly, the King of Monday Night was dethroned. His usual crowd of twelve dwindled to six, to four, and then to nothing. But if you ask Andy, he’ll tell you that he gained more than he lost.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0029-02-5"
    }
  }, [_vm._v("It will sound extreme to some, but if you are to avoid the Samson Syndrome, there must be nothing in your life—no person, no possession, no activity—that you value more than your relationship with God. If there’s "), _c('i', [_vm._v("anything")]), _vm._v(" in your life that lures you outside God’s boundaries, kiss it good-bye.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0029-02-6"
    }
  }, [_c('i', [_vm._v("Third, REBUILD the fences you’ve trampled.")]), _vm._v(" A fence is anything that keeps you from straying. It might be the disciplines of prayer, Bible study, or corporate worship that you abandoned somewhere along the way. It might be a relationship with a strong Christian that you allowed to wither and die. Or it might be some ministry or service project that kept you from having too much free time on your hands.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0029-02-7"
    }
  }, [_vm._v("I remember years ago a man in our church came to me and volunteered to teach a Sunday-school class. I thought he must be delirious. After all, nobody "), _c('i', [_vm._v("ever")]), _vm._v(" volunteers to teach a Sunday-school class. Halley’s Comet splits the eastern sky with greater regularity. But there he was, standing right in front of me, actually saying the words.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0030-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("When I asked him why, he stopped me cold with his answer.")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0030-P-1"
    }
  }, [_vm._v("He said, “I used to teach a long time ago, and I’ve come to realize that I’m a much better Christian when I’m teaching Sunday school.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0030-01-1"
    }
  }, [_vm._v("You see, for him, teaching Sunday school was a fence that helped keep him inside God’s boundaries. It kept his nose in the Word, gave him a sense of purpose, and occupied some of his free time with a worthwhile endeavor.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0030-01-2"
    }
  }, [_vm._v("Are there some fences in your life that have been trampled or that have fallen into disrepair? If so, you need to rebuild them. You need to get back to the people, places, and things that keep you in the will of God.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0030-01-4"
    }
  }, [_c('i', [_vm._v("And finally, REJOICE in the mercy and grace of a forgiving God.")]), _vm._v(" Forgiveness can be pretty hard to come by in this world. Take the odd case of Jefferson Davis, for example. He was the president of the Confederacy, and before the Civil War, had been a congressman, senator, and a member of the president’s Cabinet. But after the war he was considered a traitor. His citizenship was revoked and he was thrown into prison for two years. It wasn’t until October 17, 1978—a full eighty-nine years after his death—that Jefferson Davis was officially “forgiven” by the United States government and had his citizenship restored.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0030-01-6"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("If you’ve strayed outside God’s boundaries, and especially if your straying has hurt some people, they may find it just as hard to forgive you as our government did Jefferson Davis. Countless men have been rejected by their families and friends, or have lost their careers because of their sins. But the promise of Scripture is that God, like the prodigal son’s father, is full of mercy and grace and stands ready to welcome us home when we come in genuine repentance. First John 1:9 says, “If we confess ")]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("our sins to him, he is faithful and just to forgive us and to cleanse us from every wrong.”")])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0031-02-2"
    }
  }, [_vm._v("One of the more encouraging aspects of Samson’s story is that every time he turned to God, even if his motivations were somewhat skewed, God was there for him. And you can be sure He’ll be there for you too. Jesus said, “Come to me, "), _c('i', [_vm._v("all of you")]), _vm._v(" who are weary and carry heavy burdens, and I will give you rest” (Matt. 11:28, author’s emphasis).")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0031-02-4"
    }
  }, [_vm._v("Are there any more beautiful words in Scripture?")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbaac30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter5.vue
// module id = 81
// module chunks = 0